import { AppstoreOutlined, UserOutlined } from '@ant-design/icons';
import { Segmented } from 'antd'
import React, { useState } from 'react'
import EventManagement from './EventManagement';
import ReportManagement from './ReportManagement';

const ReportEvents = () => {
    const [activeTab, setActiveTab] = useState('events');

    const segmentOptions = [
        {
            label: (
                <div className="flex items-center gap-2">
                    <UserOutlined />
                    <span>Event Management</span>
                </div>
            ),
            value: 'events'
        },
        {
            label: (
                <div className="flex items-center gap-2">
                    <AppstoreOutlined />
                    <span>Report Management</span>
                </div>
            ),
            value: 'reports'
        },

    ];


    return (
        <div>   <div className="flex justify-start mb-2">
            <Segmented
                options={segmentOptions}
                value={activeTab}
                onChange={setActiveTab}
                className="custom-segmented"
            />
        </div>

            {/* Tab Content */}
            <div className="min-h-[500px]">
                {activeTab === 'reports' && (
                    <ReportManagement />
                )}
                {activeTab === 'events' && (
                    <EventManagement />
                )}
            </div>
        </div>
    )
}

export default ReportEvents